<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.sistemas"
                        :validations="validations.sistema"
                        label="Sistema"
                        show-default-option
                        v-model="model.sistema_id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input-autocomplete
                        :fields="fields.municipio"
                        :repository="repositories.cadastro.municipio"
                        :selected-text="model.municipio_nome"
                        :text-field="(municipio) => `${municipio.municipio_nome} - ${municipio.estado_uf}`"
                        :validations="validations.municipio"
                        label="Município"
                        v-model="model.municipio_id"
                        value-field="municipio_id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.email"
                        label="E-mail"
                        v-model="model.email"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.site"
                        label="Site"
                        v-model="model.site"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.link"
                        label="Link"
                        v-model="model.link"
                    />
                </rkm-col>
                
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.logotipo"
                        label="Logotipo"
                        v-model="model.logotipo"
                    />
                </rkm-col>

                <rkm-col cols="1">
                    <rkm-form-input
                        :validations="validations.sms_usuario"
                        label="Usuário (SMS)"
                        v-model="model.sms_usuario"
                    />
                </rkm-col>

                <rkm-col cols="1">
                    <rkm-form-input
                        :validations="validations.sms_senha"
                        label="Senha (SMS)"
                        v-model="model.sms_senha"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :validations="validations.ativo"
                        label="Ativo"
                        show-default-option
                        v-model="model.ativo"
                    >
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :validations="validations.ativo_app_conectasus_cidadao"
                        label="Ativo ConectaSUS - Cidadão"
                        show-default-option
                        v-model="model.ativo_app_conectasus_cidadao"
                    >
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.safecare_usuario"
                        label="Usuário (Safecare)"
                        v-model="model.safecare_usuario"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.safecare_senha"
                        label="Senha (Safecare)"
                        v-model="model.safecare_senha"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :maxlength="validations.motivo_inativacao.max"
                        :validations="validations.motivo_inativacao"
                        label="Motivo da inativação"
                        rows="4"
                        v-model="model.motivo_inativacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        fields() {
            return {
                municipio: [
                    {key: 'nome', name: 'cadastro_municipio.nome'},
                ],
            }
        },
        loading() {
            return this.getLoading('cadastro-cliente-form')
        },
        validations() {
            return {
                sistema: {required: true},
                municipio: {required: true},
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                email: {
                    required: true,
                    email: true,
                    min: 3,
                    max: 100,
                },
                site: {
                    required: true,
                    regex: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.(com(\.br)?|br)$/i,
                    max: 100,
                },
                link: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                logotipo: {
                    min: 3,
                    max: 100,
                },
                sms_usuario: {
                    min: 3,
                    max: 100,
                },
                sms_senha: {
                    min: 3,
                    max: 100,
                },
                ativo: {required: true},
                ativo_app_conectasus_cidadao: {required: true},
                motivo_inativacao: {max: 500},
                safecare_usuario: {
                    min: 3,
                    max: 100,
                },
                safecare_senha: {
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    data: () => ({
        form: {
            sistemas: [],
        },
        model: {
            sistema_id: null,
            municipio_id: null,
            municipio_nome: null,
            nome: null,
            email: null,
            site: null,
            link: null,
            logotipo: null,
            sms_usuario: null,
            sms_senha: null,
            ativo: null,
            ativo_app_conectasus_cidadao: null,
            motivo_inativacao: null,
            safecare_usuario: null,
            safecare_senha: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading('cadastro-cliente-form')

            if (this.id) {
                this.repositories.cadastro.cliente.edit(this.id)
                    .then(({data}) => {
                        this.form = data.form
                        this.model = data.model
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-cliente-form'))
            } else {
                this.repositories.cadastro.cliente.create()
                    .then(({data}) => {
                        this.form = data.form
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-cliente-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-cliente-form')

                        const request = {...this.model}

                        delete request.municipio_nome

                        if (this.id) {
                            this.repositories.cadastro.cliente.update(request, this.id)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-cliente-form'))
                        } else {
                            this.repositories.cadastro.cliente.store(request)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-cliente-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>